export default __webpack_public_path__ + "static/media/770.9e7e3aa9.png";